// Navigation hint only: never a credential. Protected routes still validate
// the app's own token. Share only with the production marketing hostname.
export function syncSessionHint(token, role, hostname = window.location.hostname) {
  if (hostname !== 'app.rxrooster.com') return;
  const roles = ['CRNA', 'PROVIDER', 'GROUP', 'ADMIN', 'MARKETING'];
  let maxAge = 0;
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (roles.includes(role)) {
      maxAge = Math.max(0, Math.floor(payload.exp - Date.now() / 1000));
    }
  } catch { /* No usable session: expire the hint. */ }
  if (!Number.isFinite(maxAge)) maxAge = 0;
  try {
    document.cookie = `rxr_session_hint=${maxAge > 0 ? role : ''}; Max-Age=${maxAge}; Path=/; Domain=rxrooster.com; Secure; SameSite=Lax`;
  } catch { /* Cookie restrictions must not interrupt login/logout. */ }
}
